import { render, staticRenderFns } from "./IconSpeedioNormal.vue?vue&type=template&id=927150ba&"
import script from "./IconSpeedioNormal.vue?vue&type=script&lang=ts&"
export * from "./IconSpeedioNormal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports